<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Thèmes
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-card-text>
      <v-list>
        <v-list-item
          v-for="(item, index) in Themes"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.ll_theme"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions({
      GetThemes: "Themes/GetAll",
    }),
  },
  created() {
    this.GetThemes();
  },
  computed: {
    ...mapState({
      Themes: (state) => state.Themes.Themes,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
